import { DialogObject } from '@/components/dialog/dialog.types';

export const getActivityDeleteObject = ({ store, action, toggleVisiblity }: any): DialogObject => {
  return {
    title: 'settings.activity.delete.title',
    description: '',
    onHide: () => {
      store?.reset();
    },
    actions: [
      {
        label: 'settings.activity.delete.delete',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'settings.activity.delete.cancel',
        onClick: () => {
          toggleVisiblity?.();
          store?.reset();
        },
        variant: 'secondary',
      },
    ],
  };
};
